var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"img",class:_vm.classes,on:{"click":_vm.updateCarousel}},[_c('shopify-visual',{attrs:{"data-index":_vm.index,"image":_vm.image,"expand":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }